import { render, staticRenderFns } from "./monitorOil.vue?vue&type=template&id=0be48d28&scoped=true"
import script from "./monitorOil.vue?vue&type=script&lang=js"
export * from "./monitorOil.vue?vue&type=script&lang=js"
import style0 from "./monitorOil.vue?vue&type=style&index=0&id=0be48d28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be48d28",
  null
  
)

export default component.exports